import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { APIResponse, BlobFile, BlobFileBatch } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

const httpOptionsFileUpload = {
    headers: new HttpHeaders({
        'Content-Type': 'multipart/form-data'
    })
};

const httpOptionsFileDownload = {
    headers: new HttpHeaders({
        'Content-Type': 'application/octet-stream'
    })
};

@Injectable()
export class FileService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public getBlobFilesByRecordTypeRecordID(recordType: string, recordID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/GetBlobFilesByRecordTypeRecordID/?recordType=' + recordType + "&recordID=" + recordID);
    }

    public getSearchBlobFilesByRecordTypeNameRecordID(recordTypeName: string, recordID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/GetSearchBlobFilesByRecordTypeNameRecordID/?recordTypeName=' + recordTypeName + "&recordID=" + recordID);
    }

    public saveBlobFile(blobFile: BlobFile) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Files/SaveBlobFile/', blobFile, httpOptions);
    }

    public saveBlobFileBatch(blobFileBatch: BlobFileBatch) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Files/SaveBlobFileBatch/', blobFileBatch, httpOptions);
    }

    public deleteBlobFile(blobFileID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/DeleteBlobFile/?blobFileID=' + blobFileID);
    }

    public deleteBlobFileBatch(blobFileBatchID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/DeleteBlobFileBatch/?blobFileBatchID=' + blobFileBatchID);
    }

    public list() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/ListAllBlobs/');
    }

    public download(filename: string) {
        //return this.http.get<any>(this.baseUrl + 'api/Files/Download/?filename=' + filename, httpOptionsFileDownload);
        return this.baseUrl + 'api/Files/Download/?filename=' + filename;
    }

    public downloadRateConfirmationPDF(quoteOrderLineID: number) {
        return this.baseUrl + 'api/Files/DownloadRateConfirmationPDF/?quoteOrderLineID=' + quoteOrderLineID;
    }

    public upload(blob: File) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Files/Upload/', blob, httpOptions);
    }

    public uploadRecordFile(evt: any, recordType: string, recordID: number, documentType: string) {
        // Filename convention: recordType + '-' + recordID + '-' + filename.ext;
        var file: File = evt.target.files[0];
        var ext = this.getFileExtension(file.name);
        if (ext == null) {
            ext = "";
        }
        else {
            ext = "." + ext;
        }

        var thisDate = new Date();
        var msec = Math.round(thisDate.getTime());
        var msecHex = msec.toString(16);

        var filename = recordType + "-" + recordID + "-" + documentType + "-" + msecHex + ext;
        console.log("uploadRecordFile", filename);
        var formData = new FormData();
        formData.append("file", file, filename);
        return this.http.post<APIResponse>(this.baseUrl + 'api/Files/Upload/', formData);
        //return this.http.post<APIResponse>(this.baseUrl + 'api/Files/Upload/?fileName=' + filename, file, httpOptionsFileUpload);
        //return this.http.post<APIResponse>(this.baseUrl + 'api/Files/Upload/', file, httpOptionsFileUpload);
    }

    public delete(filename: string) {
        return this.http.delete<APIResponse>(this.baseUrl + 'api/Files/Delete/?filename=' + filename);
    }

    public getDocumentTypes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/GetDocumentTypes/');
    }

    public getDocumentTypesByRecordTypeID(recordTypeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/GetDocumentTypesByRecordTypeID/?recordTypeID=' + recordTypeID);
    }

    public getDocumentTypesByRecordTypeName(recordTypeName: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/GetDocumentTypesByRecordTypeName/?recordTypeName=' + recordTypeName);
    }

    public getBlobFileBatchByBlobFileID(blobFileID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Files/GetBlobFileBatchByBlobFileID/?blobFileID=' + blobFileID);
    }

    public getFileExtension(filename: string) {
        var ext = filename.split('.').pop();
        if (ext == undefined) {
            ext = "";
        }
        return ext;
    }
}
